export default __webpack_public_path__ + "static/media/IMG_3078_5_11zon.40deaec5.jpg";